import { selectIsFetching as selectIsFetchingBarcode } from './state/barcode/selector'
import { selectIsFetching as selectIsFetchingInstanceDetail } from './state/instance-detail/selector'
import { selectIsFetching as selectIsFetchingTaskDetail } from './state/task-detail/selector'
import { selectIsFetching as selectIsFetchingTaskList } from './state/task-list/selector'

export default {
    selector: {
        selectIsFetching: (state) => {
            return (
                selectIsFetchingBarcode(state) ||
                selectIsFetchingInstanceDetail(state) ||
                selectIsFetchingTaskDetail(state) ||
                selectIsFetchingTaskList(state)
            )
        },
    },
}



// WEBPACK FOOTER //
// ./src/modules/process/index.js